import { createContext, useContext, type ReactNode } from 'react';

export type GuestActionProviderType = 'SERVICE_PROVIDER' | 'FINANCIAL_ADVISOR';

export type GuestProviderContactGateParams = {
  providerId?: string;
  providerType: GuestActionProviderType;
};

type GuestActionGateContextValue = {
  openProviderContactGate: (params: GuestProviderContactGateParams) => void;
};

const noopValue: GuestActionGateContextValue = {
  openProviderContactGate: () => {},
};

const GuestActionGateContext = createContext<GuestActionGateContextValue | null>(null);

type GuestActionGateProviderProps = {
  children: ReactNode;
  value: GuestActionGateContextValue;
};

export const GuestActionGateProvider = ({
  children,
  value,
}: GuestActionGateProviderProps) => (
  <GuestActionGateContext.Provider value={value}>
    {children}
  </GuestActionGateContext.Provider>
);

export const useGuestActionGate = (): GuestActionGateContextValue => {
  return useContext(GuestActionGateContext) ?? noopValue;
};
